import React , { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import {Card, Grid, Typography} from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import { ListaReportes } from './ListaReportes';
import { fetchReportes, reportesLimpiar, buscarReporte } from '../../actions/reportes';

const useStyles = makeStyles({
    root:{
        width:400,
        margin:30,
        padding:20
    },
    paper: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    buttonOk:{
      margin:10
    }
});

export const HomeReportes = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { cargada, items } = useSelector((state) => state.reportes);

    useEffect (() => {
      dispatch( reportesLimpiar() );
      dispatch( fetchReportes() )
    }, [dispatch])

    const handleChange = e => {
      dispatch( buscarReporte(e.target.value) );
    }

    const handleKeyPress = e => {
      if (e.which === 13) 
          e.preventDefault();
    }

    return (
        <div>
          <Grid> 
            <Grid container justify="center">
              <Card className={classes.root}>  
                  <Typography><strong>Buscar Reporte</strong></Typography>
                  <Paper component="form" className={classes.paper}>
                    <InputBase
                      className={classes.input}
                      placeholder="Nombre"
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                    />
                  </Paper>
              </Card>
            </Grid>  
            {cargada && (
              <ListaReportes items={items} />
            )}
          </Grid>
        </div>
      );
  
  };